import {AnankeTab} from "@vesta/ananke/components/anankeTab";
import {AnankeTabList} from "@vesta/ananke/components/anankeTabList";
import {AnankeTabs} from "@vesta/ananke/components/anankeTabs";
import {uniqueUuid} from "@vesta/unique/unique";

export function EntityProfileTabBar<TTabId extends string>({
    tabs,
    selectedTabId,
    onTabChange,
}: {
    tabs: Array<{id: TTabId; label: string}>;
    selectedTabId: TTabId;
    onTabChange: (tabId: TTabId) => void;
}) {
    const selectedIndex = tabs.findIndex((tab) => tab.id === selectedTabId);

    return (
        <AnankeTabs
            id={uniqueUuid`a1b2c3d4-e5f6-7890-abcd-ef1234567890`}
            selected={selectedIndex >= 0 ? selectedIndex : 0}
            onChange={(index) => {
                const tab = tabs[index];
                if (tab !== undefined) {
                    onTabChange(tab.id);
                }
            }}
        >
            {/*
              Atlaskit TabList draws an inset ::before rule. Hide it so the panel can
              own a single full-bleed separator under Events / Notes / Activity.
            */}
            <div className="[&_[role=tablist]]:before:hidden">
                <AnankeTabList>
                    {tabs.map((tab) => (
                        <AnankeTab key={tab.id}>{tab.label}</AnankeTab>
                    ))}
                </AnankeTabList>
            </div>
        </AnankeTabs>
    );
}
